import type { EventName, GA4ItemCollectionPayload, GA4ItemPayload } from "../types/GA4Types.type";

function _clearEcommerceObject() {
	/**
	 * It's recommended that you use the following command to clear the ecommerce object prior to pushing an ecommerce event to the data layer.
	 * Clearing the object will prevent multiple ecommerce events on a page from affecting each other.
	 */
	pushDataLayer({ ga4_ecommerce: null });
}

type Options = { clearEcommerceObject?: boolean };

export type GAEvent = { event: "GAevent"; event_category: string; event_action: string; event_label?: string | null };
type GA4Event = { event: EventName; ga4_ecommerce: GA4ItemPayload | GA4ItemCollectionPayload };
type GA4CustomEvent = {
	event: string;
	category: string | undefined;
	action: string | undefined;
	label: string | undefined;
	attributes: string | undefined;
	type: string | undefined;
};
type GA4ClearEcommerce = { ga4_ecommerce: null };
type EcommerceEvent = { event: string; ecommerce: Record<string, unknown> };
type RecommendationEvent = { event: string; Recommendation: typeof window.recommendationData.Recommendation };

function pushDataLayer(
	obj: GAEvent | GA4Event | GA4CustomEvent | GA4ClearEcommerce | EcommerceEvent | RecommendationEvent,
	options: Options = {}
) {
	if (options.clearEcommerceObject) _clearEcommerceObject();

	if (!window.ocm.dataLayerHelper) return;
	window.ocm.dataLayerHelper.push(obj);
}

export default pushDataLayer;
